export default "__VITE_ASSET__COob5Q$i__"